import { SpinRecord } from "./spin-record";

export class TumbleRecord extends SpinRecord {
    public id: string = "TumbleRecord";
}
